module.exports = __webpack_public_path__ + "static/media/ico_stickercontest_fb.d1ed6466.png";